<template>
  <div class="tw-flex tw-w-full tw-flex-col tw-gap-[10px] tw-mt-[10px]">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="tw-grid tw-grid-cols-[1fr_auto_70px] tw-gap-[10px] tw-justify-items-end"
    >
      <div class="tw-text-left tw-w-full">
        <span v-if="dataLang[option?.finreestr_funds__name]">
          {{ dataLang[option?.finreestr_funds__name] }}
        </span>
        <span v-else>
          {{ option?.finreestr_funds__name }}
        </span>
      </div>

      <div class="tw-flex tw-justify-end tw-gap-[5px]">
        <div
          v-if="option.finreestr_funds__id == 6"
          class="tw-w-[18px] tw-h-[18px] tw-border-forLine tw-border-solid tw-border-[1px] tw-flex tw-rounded-[3px] tw-items-center tw-justify-center tw-cursor-pointer"
          @click="
            $modal.show('assigneUserSpend', {
              datas: option,
              type: 'spend',
            })
          "
        >
          <img :src="require(`@/assets/icons/minus-red.svg`)" width="7" />
        </div>
        <div
          v-if="option.finreestr_funds__id != 6"
          class="tw-w-[18px] tw-h-[18px] tw-border-forLine tw-border-solid tw-border-[1px] tw-flex tw-rounded-[3px] tw-items-center tw-justify-center tw-cursor-pointer"
          @click="
            $modal.show('toMoveCost', {
              datas: option,
              type: 'spend',
            })
          "
        >
          <img :src="require(`@/assets/icons/minus-red.svg`)" width="7" />
        </div>
      </div>

      {{ option?.finreestr_funds__amount?.split(".")?.join(",") }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: ["options"],
  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
